import { Component, OnInit } from "@angular/core";
import {
  BehaviorSubject,
  forkJoin,
  Observable,
  of,
  Subject,
  throwError,
} from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  flatMap,
  map,
  switchMap,
  tap,
} from "rxjs/operators";

import { IonInput, IonMenu } from "@ionic/angular";
import { environment } from "src/environments/environment";
import { Group } from "../../models/group.model";
import { Restaurant } from "../../models/restaurant.model";
import { RestaurantService } from "../../services/restaurant.service";
import { Category } from "../../interfaces/category.interface";
import { V2TopBarOptions } from "../../shared/components/v2/v2-top-bar/v2-top-bar.component";
import { Utils } from "../../shared/util";
import { ProductService } from "../../services/product.service";
import { StorageService } from "src/app/services/storage.service";
import { ConfigurationService } from "src/app/services/configuration.service";
 

@Component({
  selector: "app-cardapio",
  templateUrl: "./cardapio.page.html",
  styleUrls: ["./cardapio.page.scss"],
})
export class CardapioPage implements OnInit {
  public groups$: Observable<Group[]>;
  public visibleGroups$: Observable<Group[]>;
  private rest$: Observable<Restaurant>;
  public filter$: Subject<string> = new Subject();
  public categories: Category[] = [];
  public visibleCategories: BehaviorSubject<Category[]> = new BehaviorSubject(
    []
  );
  public menuOpen: boolean;
  public searchBarOpen: boolean = false;
  _filter: boolean = false;

  constructor(
    private restService: RestaurantService,
    private prodService: ProductService,
    private utils: Utils,
    private storage: StorageService,
    private config: ConfigurationService,
     
  ) {
  /*console.log(this.config.modoApp, "modoappp");
    console.log(this.config.isTablet, "istablte");*/
  }

  ngOnInit() {
    
    const mode$ = this.storage.getV2<string>(environment.storage.v2.mode);

    mode$.subscribe((mode:string)=>{
      this.utils.setStateLoading(true);
    this.rest$ = this.restService.getRest();

    // Carrega os dados
    this.groups$ = this.rest$.pipe(
      flatMap((rest) =>
        this.prodService
          .getGroupsByMode(rest.restauranteId, 2, mode)
          .pipe(
            map((groups) => groups.sort((a, b) => a.sequencia - b.sequencia))
          )
      ),
      tap((groups) => {
        groups.forEach((group) => this.categories.push(...group.categorias));       
        this.visibleCategories.next(this.categories);
        this.utils.setStateLoading(false);        
      }))
    }, (err:Error)=>{console.log(err)})


    // Prepara o filtro de produtos
    this.filter$
      .pipe(
        debounceTime(700),
        distinctUntilChanged(),
        filter((filter) => filter != null),
        map((filter) => filter.trim().toLowerCase()),
        tap((filter) => (this._filter = !!filter)),
        map((filter) =>
          !filter
            ? this.categories
            : this.categories.map((cat) => ({
                ...cat,
                produtos: cat.produtos.filter(
                  (prod) =>
                    prod.nome.toLowerCase().includes(filter) ||
                    (prod.descricao || "").toLowerCase().includes(filter)
                ),
              }))
        ),
        map((cats) => cats.filter((cat) => cat.produtos.length > 0))
      )
      .subscribe({
        next: (cats) => this.visibleCategories.next(cats),
      });
    //console.log(this.categories, "category");
  }

  /**
   * Vai rolando as categorias no menu lateral baseado na posição da tela
   */
  onScroll() {
    const titles = document.getElementsByClassName(
      "item-category-name-title"
    ) as any as HTMLElement[];
    let idSelected: string;
    for (let ionItem of titles) {
      const categoryId = ionItem.attributes.getNamedItem("categoryid").value;
      const selectedItemMenu = document.querySelector(
        `[categoryid="${categoryId}"]`
      ) as HTMLElement;
      if (
        this.utils.isOnScreen(ionItem, { x: 0, y: 62 }) &&
        selectedItemMenu.offsetParent
      ) {
        selectedItemMenu.classList.add("active");
        idSelected = categoryId;
        const categoryList = document
          .getElementsByClassName("category-list")
          .item(0);
        categoryList.scrollTo({
          behavior: "smooth",
          top:
            selectedItemMenu.offsetTop -
            60 +
            (selectedItemMenu.offsetParent as HTMLElement).offsetTop,
        });
        break;
      }
    }

    for (let ionItem of titles) {
      const categoryId = ionItem.attributes.getNamedItem("categoryid").value;
      const selectedItemMenu = document.querySelector(
        `[categoryid="${categoryId}"]`
      );
      if (categoryId != idSelected) selectedItemMenu.classList.remove("active");
    }
  }

  
  /**
   * Vai rolando as categorias no menu superior baseado na posição da tela
   */
  onScrollTop() {
    const titles = document.getElementsByClassName(
      "item-category-name-title"
    ) as any as HTMLElement[];
    let idSelected: string;
    for (let ionItem of titles) {
      const categoryId = ionItem.attributes.getNamedItem("categoryid").value;
      const selectedItemMenu = document.querySelector(
        `[grid-categoryid="${categoryId}"]`
      ) as HTMLElement;
      if (
        this.utils.isOnScreen(ionItem, { x: 10, y: 0 }) &&
        selectedItemMenu.offsetParent
      ) {
        selectedItemMenu.classList.add("active");
        idSelected = categoryId;
        const categoryList = document
          .getElementsByClassName("grid-category").item(0);
        categoryList.scrollTo({
          behavior: "smooth",
          left:
            selectedItemMenu.offsetLeft -
            10 +
            (selectedItemMenu.offsetParent as HTMLElement).offsetLeft,
        });        
        break;
      }
    }

    for (let ionItem of titles) {
      const categoryId = ionItem.attributes.getNamedItem("categoryid").value;
      const selectedItemMenu = document.querySelector(
        `[grid-categoryid="${categoryId}"]`
      );
      if (categoryId != idSelected) selectedItemMenu.classList.remove("active");
    }
  }

  /**
   * Rola a tela para a categoria selecionada no menu lateral
   * @param categoryId
   */
  scrollToCategory(categoryId: number) {
    const scrollContent = document.getElementsByClassName("item-list").item(0);
    const itemToScroll = document.getElementById(
      `category-title-${categoryId}`
    ) as HTMLElement;

    scrollContent.scrollTo({
      behavior: "smooth",
      top: itemToScroll.offsetTop + 5,
    });
  }

  /**
   * Abre o menu lateral de grupos com categorias
   */
  toggleGroupMenu() {
    const ionMenu: IonMenu = document.getElementById("group-menu") as any;
    ionMenu.toggle();
  }

  /**
   * Muda a posição do botão de toggle do menu
   */
  menuWillOpen() {
    const toggleButton: HTMLElement =
      document.getElementById("toggle-menu-button");
    toggleButton.style.left = "304px";
    this.menuOpen = !this.menuOpen;
  }

  /**
   * Muda a posição do botão de toggle do menu
   */
  menuWillClose() {
    const toggleButton: HTMLElement =
      document.getElementById("toggle-menu-button");
    toggleButton.style.left = "0";
    this.menuOpen = !this.menuOpen;
  }

  /**
   * O tempo do timeout deve ser o mesmo tempo da transition duration da searchbar
   */
  focusInSearchbar(searchBar: IonInput) {
    setTimeout(() => searchBar.setFocus(), 800);
  }

  blurInSearchbar(searchBar: IonInput) {
    searchBar.getInputElement().then((input) => input.blur());
  }

  
}
